import {
   GET_ITEM,
   GET_ITEM_FOR_MASTER,
   UPDATE_ITEM,
   ADD_ITEM,
   GET_ITEM_GROUP,
   DELETE_ITEM,
   GET_ITEM_BY_FINISH_ITEM,
   GET_ONE_ITEM,
   GET_ITEMS,
   GET_ITEM_FOR_STOCK,
} from '../types';

// const initialState = { list: [], single: null, totalCount: 0, finishItem: [] };
const initialState = {
   list: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   single: null,
   finishItem: [],
   totalCount: 0,
   data: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_ITEM:
         return { ...state, list: payload.data, totalCount: totalCount, pagination: payload.pagination };

      case GET_ITEM_FOR_MASTER:
         return { ...state, listForMaster: payload.data, totalCountForMaster: totalCount, paginationForMaster: payload.pagination };

      case GET_ITEM_FOR_STOCK:
         return { ...state, listForStock: payload.data, totalCountForStock: totalCount, paginationForStock: payload.pagination };

      case GET_ITEMS:
         return { ...state, data: payload.data, totalCount: totalCount, pagination: payload.pagination };

      case GET_ITEM_GROUP:
         return { ...state, list: payload };

      case UPDATE_ITEM:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            totalCount: totalCount + 1,
         };

      case ADD_ITEM:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_ITEM:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ITEM_BY_FINISH_ITEM:
         return { ...state, finishItem: payload };

      case GET_ONE_ITEM:
         return { ...state, single: payload };

      default:
         return state;
   }
};

export default reducer;
